<!-- Obs: Foi retirada a tag 'app-ondadoverao' -->
<app-nbp-loading></app-nbp-loading>
<!-- Header component -->
<app-header></app-header>
<!-- Header component -->

<div class="box-padding bg-color">

  <div id ="container" class="container">
    <div [hidden]="!loading" class="loader">
      <h2>Carregando...</h2>
    </div>
    <div [hidden]="loading" class="router-output">
      <router-outlet></router-outlet>
    </div>

  </div>
</div>

<!-- Footer component -->
<app-footer></app-footer>
<!-- Footer component -->



// WEBPACK FOOTER //
// ./src/app/app.component.html